import React from 'react';
import { Handle, Position } from 'reactflow';
import { FileSpreadsheet } from 'lucide-react';

const WorksheetNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-yellow-200 node-worksheet">
      <div className="flex items-center">
        <FileSpreadsheet className="w-4 h-4 text-yellow-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-yellow-800">Worksheet Creator</div>
          <div className="text-sm text-gray-600">
            {data.config?.concept || 'Multi-grade worksheet'}
          </div>
          <div className="text-xs text-yellow-600">
            Grades: {data.config?.grades?.join(', ') || '3, 4, 5'} • {data.config?.language || 'English'}
          </div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        id="input"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-yellow-500 border-2 border-white"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-yellow-500 border-2 border-white"
      />
    </div>
  );
};

export default WorksheetNode;